import { serializeTokens } from './tokens';
import { SerializedFarmConfig } from './types';

const serializedTokens = serializeTokens();

const farms: SerializedFarmConfig[] = [
  {
    pid: 1,
    lpSymbol: 'WBESC-BUSDC LP',
    lpAddresses: {
      2372: '0x60Df24A452A62F7999F917aD7645F5995F42F79f',
    },
    token: serializedTokens.weth, // WBESC
    quoteToken: serializedTokens.usdc, // BUSDC
  },
  {
    pid: 2,
    lpSymbol: 'MONEY-WBESC LP',
    lpAddresses: {
      2372: '0x8440883DBf81C930805422f0Bc8ee3671E721e77',
    },
    token: serializedTokens.cake, // MONEY
    quoteToken: serializedTokens.weth, // WBESC
  },
  {
    pid: 3,
    lpSymbol: 'MONEY-BUSDC LP',
    lpAddresses: {
      2372: '0x7F5A86331522479c2E945E81ceD042AC34922418',
    },
    token: serializedTokens.cake, // MONEY
    quoteToken: serializedTokens.usdc, // BUSDC
  },
  {
    pid: 4,
    lpSymbol: 'MSMIL-WBESC LP',
    lpAddresses: {
      2372: '0x170af8c6f5e23fa52ac43a025914f0f603345c66',
    },
    token: serializedTokens.MSMIL, // MONEY
    quoteToken: serializedTokens.weth, // BUSDC
  },
];

export default farms;